<template>
  <nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent" id="navbar-right-navigation">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-toggle">
          <button type="button" class="navbar-toggler">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" href="#pablo"></a>
      </div>
      <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div id="navigation" class="collapse navbar-collapse justify-content-end">
        <div class="nav-item mr-2">
          <button class="btn btn-outline-primary" @click="showHelp()">
            <i class="fa fa-question mr-1" ></i>{{ $t('common.help') }}
          </button>
        </div>
        <div class="nav-item mr-2">
          <button class="btn btn-outline-primary" @click="downloadPluginZipFile(item)">
            <i class="fa fa-download mr-1"></i> {{ $t('common.download_kintone_plugin') }}
          </button>
        </div>
        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ loginUser }}
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a href="#" class="dropdown-item" @click="setLang('en')">{{$t('common.lang_en')}} </a> 
              <a href="#" class="dropdown-item" @click="setLang('ja')">{{$t('common.lang_ja')}} </a> 
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item" @click="logout">{{$t('common.logout')}}</a> 
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { LOCAL_STORAGE_KEY } from '../const/localstorageKey';
import AuthService from "../services/AuthService";
import axios from 'axios';
import KintonePluginZip from '@/assets/kintone_plugin/aintone_kintone_plugin.zip';

export default {
  data() {
        return {
            item: {
                label: 'aintone_kintone_plugin.zip',
                // copy the file to your public folder
                url: KintonePluginZip
              },
              loginUser:""
        }
  },
  mounted() {
    let user = AuthService.getUserCurrentLogin();
    if (user) {
      if (user.last_name != null) {
        this.loginUser = user.last_name;
      if (user.first_name != null)
        this.loginUser = this.loginUser + " " + user.first_name;
      }
      if (this.loginUser == "") {
        this.loginUser = user.email;
      }
    }
  },
  methods: {
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem(LOCAL_STORAGE_KEY.LANGUAGE, this.$i18n.locale);
      document.title = this.$t(`${this.$route.meta.title}.title_page`);
    },
    logout() {
      AuthService.removeToken();
      this.$router.push('/login');
    },
    downloadPluginZipFile ({ url, label }) {
      axios.get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    showHelp() {
      window.open('https://docs.aintone-plus.com', '_blank');
    }
  }
};
</script>
